import type { DisplayState } from '../shared/protocol.ts';

const KEY = 'rifq.completed-video';
// Finish on each viewer's actual ended event, never a timer or another iPad's
// progress. Reconnect/reload must not replay the same completed presentation.
export function completedPlayback(): string {
  try { return sessionStorage.getItem(KEY) || ''; } catch { return ''; }
}
export function rememberPlayback(id: string) {
  try { sessionStorage.setItem(KEY, id); } catch { /* In-memory state still works. */ }
}
export function shouldShowVideo(video: NonNullable<DisplayState['video']>, completed: string): boolean {
  return !(video.returnToSlide && video.playbackId && video.playbackId === completed);
}
